import { Component, Input, OnInit } from '@angular/core';
import { Settings } from '../models/Settings';
import { FoodPortalStateService } from '../services/food-portal-state.service';
import { InitalizeService } from '../services/initalize.service';

@Component({
    selector: 'pi-disclaimer',
    templateUrl: './disclaimer.component.html',
    styleUrls: ['./disclaimer.component.scss'],
    standalone: false
})
export class DisclaimerComponent implements OnInit {

  @Input() settings: Settings;

  constructor(
    private initializeService: InitalizeService,
    private state: FoodPortalStateService
  ) { }

  ngOnInit() {
    this.settings = this.state.portalSettings;
  }

  closeDisclaimerPage() {
    this.initializeService.setShowDisclaimer(false);
  }

}
